const es = {
    translation: {
        core: {
            cardDetails: {
                accountEnding: 'Cuenta que termina en {{accountLast4}}'
            },
            errorMessages: {
                havingTrouble: 'Tenemos problemas para recuperar su información',
                tryAgainLater: 'Por favor, vuelva a intentarlo más tarde.'
            }
        }
    }
};
export default es;
